import { useLayoutEffect } from 'react';

export default function AutoC2CFrame () {
  const FRAME_SCRIPT_URL = 'https://c2c24.pl/init/frames.js';

  const isFrameScriptExists = document.querySelector(`script[src="${FRAME_SCRIPT_URL}"]`) !== null;
  if (!isFrameScriptExists) {
    const script = document.createElement('script');
    script.src = FRAME_SCRIPT_URL;
    script.async = true;
    document.body.appendChild(script);
  }

  useLayoutEffect(() => {
    document.dispatchEvent(new Event('liveArticleUpdated'));
  }, []);

  return (
    <div className='auto-c2c-frame-embed'>
      <script data-frameid data-items='6' data-tool='auto' />
    </div>
  );
}
